import { toAbsoluteApiUrl } from '../../../../../../../helpers/http-client';

export const getInitials = (text = '') => {
    const safeText = String(text || '').trim();
    if (!safeText) {
        return 'US';
    }

    const words = safeText.split(/\s+/).filter(Boolean);
    if (words.length === 1) {
        return words[0].slice(0, 2).toUpperCase();
    }

    return `${words[0][0] || ''}${words[1][0] || ''}`.toUpperCase();
};

export const getPasswordRules = (passwordStrength) => {
    return [
        { key: 'length', label: 'Al menos 8 caracteres', valid: passwordStrength.checks.length },
        { key: 'lowercase', label: 'Una letra minúscula', valid: passwordStrength.checks.lowercase },
        { key: 'uppercase', label: 'Una letra mayúscula', valid: passwordStrength.checks.uppercase },
        { key: 'numbers', label: 'Un número', valid: passwordStrength.checks.numbers },
        { key: 'special', label: 'Un carácter especial', valid: passwordStrength.checks.special },
    ];
};

export const resolveFilePublicUrl = (fileData = {}) => {
    const directUrl = String(fileData.url || fileData.publicUrl || '').trim();
    if (directUrl) {
        return toAbsoluteApiUrl(directUrl);
    }

    const fileId = String(fileData._id || '').trim();
    if (!fileId) {
        return '';
    }

    return toAbsoluteApiUrl(`/api/file/public/${fileId}/content`);
};
